import { Dispatch } from 'react';
import { StatePair } from '../../../UnicronApp/preloader/StatePair';
import { ErrorHarness } from '../../../common/components/ErrorHarness/ErrorHarness';
import { useAutoCompleteAllergens } from '../../../common/hooks/autocomplete/useAutoCompleteAllergens';
import { useAutoCompleteCulturalBackgrounds } from '../../../common/hooks/autocomplete/useAutoCompleteCulturalBackgrounds';
import { useAutoCompleteLanguages } from '../../../common/hooks/autocomplete/useAutoCompleteLanguages';
import { useAutoCompleteMedications } from '../../../common/hooks/autocomplete/useAutoCompleteMedications';
import { useAutoCompleteOccupations } from '../../../common/hooks/autocomplete/useAutoCompleteOccupations';
import { useAutoCompleteSuburbs } from '../../../common/hooks/autocomplete/useAutoCompleteSuburbs';
import { AutoCompleteField } from './AutoComplete/AutoCompleteField';
import { PredictionType, SuburbPredictionType } from './AutoComplete/PredictionType';

export interface Props<T> {
  id?: string;
  labelKey?: string;
  placeholder?: string;
  required?: boolean;
  complete?: boolean;
  errorMessage?: string | string[];
  hasError?: boolean;
  className?: string;
  disabled?: boolean;
  state: StatePair<string | undefined>;
  onSelectPrediction?: Dispatch<T>;
  onClear?: Dispatch<string>;
  autoComplete?: string;
  allowCustom?: boolean;
}

export const AutoCompleteSuburbField = ({
  errorMessage,
  hasError,
  ...autoCompleteFieldProps
}: Props<SuburbPredictionType>) => (
  <ErrorHarness errorMessage={errorMessage}>
    <AutoCompleteField
      autoCompleteHook={useAutoCompleteSuburbs}
      error={hasError}
      {...autoCompleteFieldProps}
    />
  </ErrorHarness>
);

export const AutoCompleteSuburbFieldWithoutError = ({
  errorMessage,
  hasError,
  ...autoCompleteFieldProps
}: Props<SuburbPredictionType>) => (
  <AutoCompleteField
    autoCompleteHook={useAutoCompleteSuburbs}
    error={hasError}
    {...autoCompleteFieldProps}
  />
);

export const AutoCompleteCulturalBackgroundField = ({
  errorMessage,
  ...autoCompleteFieldProps
}: Props<PredictionType>) => (
  <ErrorHarness errorMessage={errorMessage}>
    <AutoCompleteField
      autoCompleteHook={useAutoCompleteCulturalBackgrounds}
      {...autoCompleteFieldProps}
    />
  </ErrorHarness>
);

export const AutoCompleteLanguageField = ({
  errorMessage,
  ...autoCompleteFieldProps
}: Props<PredictionType>) => (
  <ErrorHarness errorMessage={errorMessage}>
    <AutoCompleteField autoCompleteHook={useAutoCompleteLanguages} {...autoCompleteFieldProps} />
  </ErrorHarness>
);

export const AutoCompleteOccupationField = ({
  errorMessage,
  ...autoCompleteFieldProps
}: Props<PredictionType>) => (
  <ErrorHarness errorMessage={errorMessage}>
    <AutoCompleteField autoCompleteHook={useAutoCompleteOccupations} {...autoCompleteFieldProps} />
  </ErrorHarness>
);

export const AutoCompleteMedicationField = ({
  errorMessage,
  ...autoCompleteFieldProps
}: Props<PredictionType>) => (
  <ErrorHarness errorMessage={errorMessage}>
    <AutoCompleteField
      error={!!errorMessage}
      autoCompleteHook={useAutoCompleteMedications}
      {...autoCompleteFieldProps}
    />
  </ErrorHarness>
);

export const AutoCompleteAllergensField = ({
  errorMessage,
  ...autoCompleteFieldProps
}: Props<PredictionType>) => (
  <ErrorHarness errorMessage={errorMessage}>
    <AutoCompleteField
      error={!!errorMessage}
      autoCompleteHook={useAutoCompleteAllergens}
      {...autoCompleteFieldProps}
    />
  </ErrorHarness>
);
